import React from "react";

const Education = () => {
  return (
    <div>
      <h4 className="resume-heading">Education</h4>

      <div id="education" className="resume_screen_container">
        <div className="resume_heading">
          <div className="resume_main_heading">
            <div className="heading_bullet"></div>
            <span>National University Of Bangladesh, Gazipur</span>
            <div className="heading_date">running at 2019 </div>
          </div>
          <div className="resume_sub_heading">
            <span>Bachelor of Science.</span>
          </div>
          <div className="resume_heading_description">
            <span></span>
          </div>
        </div>
        <div className="resume_heading">
          <div className="resume_main_heading">
            <div className="heading_bullet"></div>
            <span>Shibpur Model College, Shibpur, Narsingdi</span>
            <div className="heading_date">2016-2018</div>
          </div>
          <div className="resume_sub_heading">
            <span>Science Department</span>
          </div>
          <div className="resume_heading_description">
            <span></span>
          </div>
        </div>
        <div className="resume_heading">
          <div className="resume_main_heading">
            <div className="heading_bullet"></div>
            <span>High School, Daripura , Shibpur</span>
            <div className="heading_date">2011-2016</div>
          </div>
          <div className="resume_sub_heading">
            <span>Daripura Model High School, Science Department</span>
          </div>
          <div className="resume_heading_description">
            <span></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Education;
